// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("react-intl");
var __webpack_exports__ = __webpack_require__("../../../../usr/lib/node_modules/intl/index.js");
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
